"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fold = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Fold = () => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10 18" }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M-7-3h24v24H-7z" }), (0, jsx_runtime_1.jsx)("path", { d: "m5 2.83 2.46 2.46a.996.996 0 1 0 1.41-1.41L5.7.7a.996.996 0 0 0-1.41 0L1.12 3.88a.996.996 0 1 0 1.41 1.41L5 2.83Zm0 12.34-2.46-2.46a.996.996 0 1 0-1.41 1.41L4.3 17.3c.39.39 1.02.39 1.41 0l3.17-3.17a.996.996 0 1 0-1.41-1.41L5 15.17Z", fill: "currentcolor" })] })) })));
};
exports.Fold = Fold;
